import { ParsedUserProduct } from '@/queries/products/types';
import { useSelector } from '@/redux/helper';
import {
  selectHasEducatorFeature,
  selectHasExplorerFeature,
  selectHasGuidedExperienceFeature,
  selectHasSingletonFeature,
} from '@/redux/selectors/users';

import { resolveUpsellProduct, type UpsellType } from './utils';

/** Reads the feature/persona selectors an upsell decision needs, so detail views pass only the two real inputs. */
const useResolveUpsellProduct = (
  userProduct: ParsedUserProduct,
  activeUserProducts: ParsedUserProduct[],
): UpsellType | null => {
  const hasGuidedExperience = useSelector(selectHasGuidedExperienceFeature);
  const hasSingletonFeature = useSelector(selectHasSingletonFeature);
  const hasExplorerFeature = useSelector(selectHasExplorerFeature);
  const hasEducatorFeature = useSelector(selectHasEducatorFeature);
  const isEducator = useSelector((state) => state.user.persona === 'educator');

  return resolveUpsellProduct({
    userProduct,
    activeUserProducts,
    hasGuidedExperience,
    hasSingletonFeature,
    hasExplorerFeature,
    hasEducatorFeature,
    isEducator,
  });
};

export default useResolveUpsellProduct;
